import React from "react"
import styled, { css } from "styled-components"
import { motion } from "framer-motion"
import { getMediaQueries } from "@abmg-components"

import Icon from "../global/icon"

// const size = {
//   tablet: 850,
//   mobile: 600,
// }
// const below = Object.keys(size).reduce((acc, label) => {
//   acc[label] = (...args) => css`
//     @media (max-width: ${size[label]}px) {
//       ${css(...args)};
//     }
//   `
//   return acc
// }, {})
const { below } = getMediaQueries()

const RatingWrapper = styled.div`
  height: 224px;
  max-width: 400px;
  padding: 32px;
  background-color: white;
  box-shadow: 0px 2px 24px rgba(117, 128, 143, 0.1);
  border-radius: 10px;
  margin: 0 auto;
  min-width: 227px;
  .rating-title {
    color: var(--grey);
    font-size: 16px;
    line-height: 20px;
    font-weight: 400;
    text-align: center;
    margin-bottom: 0;
  }
  ${below.mobile`
  padding: 24px;
  `}
`
const Rating = styled.p`
  font-size: 72px;
  line-height: 104px;
  font-weight: 500;
  letter-spacing: -1.25px;
  color: var(--alt-black);
  margin-bottom: 0px;
  ${below.mobile`
  font-size: 56px;
  `}
`
const IconWrapper = styled.div`
  max-width: 80px;
  max-height: 80px;
  width: 80px;
  height: 80px;
  ${below.mobile`
  width: 64px;
  height: 64px;
  `}
`
const FlexContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  margin: 12px 0;
`
const Gutter = styled.div`
  min-width: 16px;
  max-width: 16px;
`
const Attribution = styled.div`
  margin: 0 auto;
  text-align: center;
  font-size: 14px;
  line-height: 16px;
  color: var(--grey);
  a {
    color: var(--pacific-blue);
  }
`

const RatingCard = props => {
  return (
    <RatingWrapper>
      {props.dataLoaded && (
        <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }}>
          <p className="rating-title">
            {!props.locationId || !props.rating || !props.reviewCount
              ? "Atlantic Bay's Rating"
              : "My Borrower Rating"}
          </p>
          <FlexContainer>
            <Rating>
              {!props.rating || !props.reviewCount ? "4.91" : props.rating}
            </Rating>
            <Gutter />
            <IconWrapper>
              <Icon icon="big-star" />
            </IconWrapper>
          </FlexContainer>
          <Attribution>
            Based on{" "}
            <a
              href={`${
                props.microSite
                  ? props.microSite
                  : "https://pro.experience.com/reviews/office/atlantic-bay-mortgage-virgnia-beach-46727"
              }`}
              rel="noopener noreferrer"
              target="_blank"
            >
              {`${props.reviewCount ? props.reviewCount : "6,000+"} ratings`}
            </a>
          </Attribution>
        </motion.div>
      )}
    </RatingWrapper>
  )
}

export default RatingCard
